import React from "react";
import { AlcoholModal } from "src/storefront/components/alcohol_modal";
import {
    RestrictionModalFactory,
} from "src/storefront/types/restriction_modal_factories/index";
import { RestrictionType } from "../storefront";

export class AlcoholModalFactory implements RestrictionModalFactory {
    type: RestrictionType;

    constructor() {
        this.type = RestrictionType.age_r18;
    }

    modal = (onConfirm: () => void, onClose: () => void) => {
        return <AlcoholModal onClose={onClose} onConfirm={onConfirm} />
    }
}

